import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, KeyValue, SectionHeader } from 'web-library';
import PaymentStatusPill from '../../../components/pills/PaymentStatusPill';

const SummaryTransactionDetail = ({
  transactionNo,
  paymentStatus,
  paymentMode,
  internalRef,
}: any) => {
  const { t } = useTranslation();
  return (
    <>
      <SectionHeader title={t('exam->>RegistrationSummary.TransactionDetails')} />
      <Grid container direction="row">
        <Grid md={6} sm={12}>
          <KeyValue
            keyText={t('exam->>TransactionDetails.RefNo')}
            valueText={internalRef === '-' ? 'N/A' : internalRef}
          />
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid md={6} sm={12}>
          <KeyValue
            keyText={t('exam->>TransactionDetails.TransactionNo')}
            valueText={transactionNo === '-' ? 'N/A' : transactionNo}
          />
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            keyText={t('exam->>TransactionDetails.PaymentMethod')}
            valueText={paymentMode === '-' ? 'N/A' : paymentMode}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            keyText={t('exam->>TransactionDetails.PaymentStatus')}
            valueText={
              <Grid>
                <PaymentStatusPill paymentStatus={paymentStatus} />
              </Grid>
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SummaryTransactionDetail;
